module.exports = __webpack_public_path__ + "assets/35f07287a29d408479fd60a01c452fdd.mp3";